export const BannerForShimmer = ({ eventDate }) => {
  const getDaysLeft = () => {
    if (!eventDate) return null;

    const event = new Date(eventDate);
    const today = new Date();

    event.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffTime = today - event;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // 1. Get the positive number so we can check if it is 1
      const count = Math.abs(diffDays);

// 2. Decide if we should use "Day" or "Days"
      const dayText = count === 1 ? "Day" : "Days";

// 3. Return the correct phrase
      if (diffDays < 0) {
          return `${count} ${dayText} to Go`;
      }
      else if (diffDays === 0) {
          return `It’s Finally Here`;
      }
      else {
          return `${count} ${dayText} Together`;
      }

    //return diffDays > 0 ? `${diffDays} Days Together` : diffDays === 0 ? `TODAY` : `EVENT PASSED`;
  };

  return (
    <div className="w-full shimmer">
      <svg viewBox="0 0 320 34.496" fill="#ffffffd2">
        <path d="M32.931 0h254.49v34.927H32.931ZM0 3.258l16.527 13.389L0 31.67h30.413V3.258H0Zm320.352 0-16.527 13.389 16.527 15.025h-30.406V3.258h30.406Z" />
        <text
          x="50%"
          y="70%"
          textAnchor="middle"
          fill="black"
          fontSize="20"
          fontFamily="Arial"
        >
          {getDaysLeft()}
        </text>
      </svg>
    </div>
  );
};

export const VideoButton = (props) => (
    <svg width={30} height={30} viewBox="0 0 24 24" {...props}>
        <path
            fill="@android:color/white"
            d="m10 16.5 6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        />
    </svg>
);

export const CameraIcon = (props) => (
    <svg width={35} height={35} viewBox="0 0 24 24" {...props}>
        <path
            fill="@android:color/white"
            d="M8.8 12a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 1 1-6.4 0"
        />
        <path
            fill="@android:color/white"
            d="M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
        />
    </svg>
);

export const VideoIcon = (props) => (
    <svg width={35} height={35} viewBox="0 0 24 24" {...props}>
        <path
            fill="@android:color/white"
            d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
        />
    </svg>
);

export const BackArrowIcon = (props) => (
    <svg viewBox="0 0 24 24" xmlSpace="preserve" {...props}>
        <path d="M12 1.2C6 1.2 1.2 6 1.2 12S6 22.8 12 22.8 22.8 18 22.8 12 18 1.2 12 1.2m7.1 11.4q-.3.3-.6.3H8.6l4.3 4.3c.2.2.3.4.2.6q0 .3-.3.6c-.2.2-.4.2-.6.2s-.4-.1-.6-.2l-5.8-5.8c-.1-.1-.2-.2-.2-.3s-.1-.2-.1-.3 0-.2.1-.3c0-.1.1-.2.2-.3l5.8-5.8c.2-.2.4-.2.6-.2s.4.1.6.2q.3.3.3.6c0 .2-.1.5-.3.6l-4.3 4.3h9.8c.2 0 .5.1.6.2.2.2.2.4.2.6s.1.6 0 .7" />
    </svg>
);

export const WeddingUnderline = ({ color, lineWidth }) => (
    <svg
        viewBox="0 0 100 7.4"
        style={{
            enableBackground: "new 0 0 100 7.4",
        }}
        fill={color}
        // width={lineWidth}
        className="lg:w-[280px] md:w-[220px] sm:w-[180px]"
    >
        <path d="M53.2 2.2c-.6.1-1.1.6-1 1.2.1.6.6 1.1 1.2 1 .6-.1 1-.6 1-1.1 0-.7-.6-1.1-1.2-1.1zm-6.7 0c-.6 0-1.1.4-1.1 1v.1c0 .6.4 1.1 1 1.1h.1c.7 0 1.2-.5 1.2-1.1 0-.6-.5-1.1-1.2-1.1z" />
        <path d="M71.9 2.9c-.2-.8-.8-1.2-1.4-1.7l-.3-.3c-2.3-1.3-4.7-1.2-6.9.1-1.6.9-3.2 2.1-5.2 1.7-.4-.1-.7 0-.9-.4-.7-1.5-2.3-2.3-4-2-1.7.2-3.1 1.6-3.1 2.8-.4 0-.3-.3-.4-.5C49 1 47.8.3 46.3.2c-1.5-.1-2.9.5-3.6 2-.1.3-.3.5-.6.5-1.5-.1-3 .2-4.3-1-.6-.5-1.4-.9-2.2-1.2-2.5-1.1-6.1-.6-7.6 2-.2.3-.4.3-.7.3-2.5 0-4.9.1-7.4.1-6.2.2-12.5.2-18.8.3H0c.9.2 1.7.3 2.6.3 3.7.1 7.5 0 11.2.1 4.3.1 8.7.1 13 .2.6 0 .8.2.8.8 0 1 .7 1.7 1.5 2.2 1.1.8 2.7.7 3.5-.6.3-.5.8-.9 1.3-1.1-.5-.1-1.1-.1-1.6 0-.6.1-1.1.5-1.6.7-1.1.4-2.1.2-2.5-.6-.2-.4-.3-.8-.2-1.2.1-.4.6-.2.9-.2 2.8 0 5.6 0 8.5.1.9 0 1.7.2 2.5.8.4.3.9.6 1.4.9 1.6 1 3.3 1.7 5.3 1.5 1.6-.1 3.1-1.3 3.3-2.7h.3c-.1.6.2 1 .6 1.3 1.2 1.4 3.5 1.8 5.5 1 1.4-.5 2.6-1.2 3.8-2.1.5-.4 1-.8 1.7-.8 3.4-.1 6.8-.2 10.2-.1.2 1-.2 1.8-1.2 2.2-.8.1-1.6-.1-2.3-.6-.9-.5-1.7-.6-2.3-.2.5.2.8.6 1.1 1 1.1 1.4 2.5 1.5 3.8.3.9-.5 1.2-1.4 1.1-2.5l15.9-.3c2.9 0 5.8 0 8.6-.1 1 0 2.1.1 3.2-.2l-28-.4zm-43.5-.1c1.7-2.7 6-2.1 8.1-.1-2.7.1-5.3.3-8.1.1zM46 6.2c-1.6-.3-3-1-4.6-2.1h3.3c.1 0 .1-.1.1-.1-.2-.9.2-1.4.2-1.4h-.4c-.2.1-.6 0-.7-.2-.1-.2.1-.4.3-.6.7-1 1.9-1.3 3.2-.9 1.1.3 1.9 1.3 2 2.5v.5c-.3 1.6-1.8 2.6-3.4 2.3zm7.7 0c-1.3.2-2.8-.6-3.2-1.7-.4-1.2.1-2.5 1.1-3.2 1.3-.8 2.9-.7 3.9.3.2.2.5.5.4.9-.1.3-.5.3-.7.2h-.3s.4.5.1 1.3c-.1 0 0 0 0 .1h3.2c-1.4 1.1-2.8 1.8-4.5 2.1zm9.6-3.5c1.4-1.4 4.4-2.4 6.9-1.1.4.4 1 .6 1.2 1.3-2.8 0-5.4-.1-8.1-.2z" />
    </svg>
);

export const Phone = (props) => (
    <svg viewBox="0 0 24 24" xmlSpace="preserve" {...props}>
        <path
            d="M16.3 21.2c-.1-.1-.3-.1-.4-.1-.7-.1-1.3-.4-2-.6-.8-.3-1.6-.6-2.3-1-.9-.5-1.8-1.1-2.6-1.8-1.3-1.2-2.6-2.4-3.6-3.9-.8-1.1-1.3-2.2-1.8-3.5-.3-.6-.5-1.2-.7-1.9-.3-1.3-.1-2.5.5-3.6.2-.4.4-.7.7-1 .3-.3.6-.6 1.1-.7.5-.1 1-.3 1.5-.3.1 0 .2 0 .3.1 0 0 .1 0 .2.1.1.2.3.4.4.6L8.8 6c.2.2.4.4.5.7.1.1.1.3.2.4 0 .1 0 .3-.1.4-.2.3-.4.5-.7.8-.3.3-.7.5-1.1.9-.1.1-.3.2-.4.4 0 .1-.1.2-.1.2v.2c0 .1.1.3.2.4.5.9 1 1.7 1.6 2.5 1.1 1.4 2.4 2.5 3.9 3.3.3.2.6.4.9.5.3.1.5.1.7-.1.3-.3.6-.6.8-.9.3-.4.6-.7.9-1 .3-.3.6-.3 1-.1l.9.6c.8.5 1.6.9 2.4 1.3.1.1.2.1.3.2.1.1.2.2.3.4v.9c-.1.4-.2.8-.3 1.1-.1.3-.4.6-.6.8-.7.5-1.5 1-2.3 1.2-.2.1-.4.1-.6.1h-.9z"
            style={
                {
                    // fill: "#010101",
                }
            }
        />
    </svg>
);

export const Facebook = (props) => (
    <svg
        viewBox="0 0 24 24"
        style={{
            enableBackground: "new 0 0 24 24",
        }}
        xmlSpace="preserve"
        {...props}
    >
        <path
            d="M13.3 14.7h2.1c.2-.9.3-1.7.5-2.6h-2.5v-1.7c.1-.9.6-1.4 1.4-1.4h1.3c0-.7 0-1.5.1-2.2-.3 0-.6-.1-.8-.1-.5 0-1-.1-1.5-.1-1.6 0-2.9 1.1-3.1 2.7-.1.6-.1 1.2-.1 1.8v1H8.3c0 .9 0 1.7-.1 2.6h2.3c-.1 2.1-.1 4.2-.2 6.3-.2 0-.4-.1-.5-.1-2.6-.6-4.6-2.1-5.8-4.5-.5-1-.9-2.1-1-3.2-.3-2.6.4-4.9 2.1-6.9 1.4-1.7 3.2-2.8 5.4-3.2 2.7-.5 5.2.1 7.3 1.9 1.7 1.4 2.7 3.2 3.1 5.4.3 2 0 4-1 5.8-.9 1.6-2.2 2.9-3.8 3.8-.9.5-1.8.8-2.7.9h-.2c0-2 .1-4.1.1-6.2z"
            // style={{
            //     fill: "#010101",
            // }}
        />
    </svg>
);

export const Instagram = (props) => (
    <svg
        viewBox="0 0 24 24"
        style={{
            enableBackground: "new 0 0 24 24",
        }}
        xmlSpace="preserve"
        {...props}
    >
        <path
            d="M8 3C5.2 3 3 5.2 3 8v8c0 2.8 2.2 5 5 5h8c2.8 0 5-2.2 5-5V8c0-2.8-2.2-5-5-5H8zm10 2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm-6 2c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5zm0 2c-.8 0-1.6.3-2.1.9-.6.5-.9 1.3-.9 2.1s.3 1.6.9 2.1c.6.6 1.3.9 2.1.9s1.6-.3 2.1-.9c.6-.6.9-1.3.9-2.1s-.3-1.6-.9-2.1c-.5-.6-1.3-.9-2.1-.9z"
            // style={{
            //     fill: "#010101",
            // }}
        />
    </svg>
);

export const Whatsapp = (props) => (
    <svg
        viewBox="0 0 24 24"
        style={{
            enableBackground: "new 0 0 24 24",
        }}
        xmlSpace="preserve"
        {...props}
    >
        <path
            d="M18.4 5.6C16.7 4 14.5 3 12 3c-4.9 0-9 4-9 9 0 1.6.4 3.1 1.2 4.4L3 21l4.8-1.1c1.3.7 2.8 1.1 4.2 1.1 5 0 9-4 9-9 0-2.4-.9-4.7-2.6-6.4zm-9.9 6.7c-.1-.2-1-1.2-1-2.3s.6-1.7.8-1.8c.2-.3.4-.3.6-.3h.4c.2 0 .3-.1.5.3s.6 1.6.7 1.7c.1.1.1.3 0 .4-.1.2-.1.3-.3.3-.1.2-.3.3-.3.4-.1.1-.3.3-.1.4.2.3.6 1 1.2 1.6.9.8 1.6 1 1.8 1.1.3.1.3.1.5-.1s.5-.7.7-.9c.2-.3.3-.2.5-.1s1.3.6 1.6.7c.3.1.3.2.4.3.1.1.1.5-.2 1-.2.5-1 1-1.5 1-.3.1-.9.1-1.4-.1-.3-.1-.8-.3-1.3-.4-2.1-.8-3.5-3-3.6-3.2z"
            // style={{
            //     fill: "#010101",
            // }}
        />
    </svg>
);

export const Youtube = (props) => (
    <svg
        viewBox="0 0 24 24"
        style={{
            enableBackground: "new 0 0 24 24",
        }}
        {...props}
    >
        <path
            d="M11.5 19.5c-.6 0-2.3 0-3.7-.1-.9 0-1.8-.1-2.7-.3-.4 0-.9-.1-1.1-.4-.5-.4-1-1.1-1.1-1.8-.1-.9-.3-1.9-.3-2.7 0-1.3-.1-2.5 0-3.7 0-1.3.1-2.5.3-3.7.1-1.1 1-1.9 1.8-2s1.7-.3 2.5-.3H13c1.4 0 2.8.1 4.1.1.5 0 1.3.1 1.8.1 1.1.1 1.8 1.1 2 2.3.1.9.3 1.7.3 2.5 0 1.1.1 2.3 0 3.3 0 1.4-.1 2.7-.4 4.1-.1 1.1-1 1.9-1.8 2-.6.1-1.4.3-2 .3-1.5.3-3.2.3-5.5.3zm-1.3-4.3c1.7-1.1 3.3-2 4.9-3.2-1.7-1.1-3.3-2-4.9-3.2v6.4z"
            // style={{
            //   fill: "#010101",
            // }}
        />
    </svg>
);

// TikTok
export const TikTok = (props) => (
  <svg
    viewBox="0 0 24 24"
    style={{ enableBackground: "new 0 0 24 24" }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M12.5 2h3.1c.1 1.1.5 2.2 1.2 3 1 1.1 2.3 1.7 3.8 1.8v3.3c-1.5 0-3-.4-4.4-1.1v7.5c0 2.9-2.4 5.3-5.3 5.3S5.6 19.4 5.6 16.5s2.4-5.3 5.3-5.3c.3 0 .6 0 .9.1v3.4c-.3-.1-.6-.1-.9-.1-1 0-1.9.9-1.9 1.9s.9 1.9 1.9 1.9c1 0 1.9-.9 1.9-1.9V2z" />
  </svg>
);

// Twitter
export const Twitter = (props) => (
  <svg
    viewBox="0 0 24 24"
    style={{ enableBackground: "new 0 0 24 24" }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.25 4.25 0 0 0 1.88-2.34 8.6 8.6 0 0 1-2.71 1.04 4.24 4.24 0 0 0-7.22 3.87A12.05 12.05 0 0 1 3.15 4.9a4.24 4.24 0 0 0 1.31 5.66 4.2 4.2 0 0 1-1.92-.53v.05a4.24 4.24 0 0 0 3.4 4.16 4.2 4.2 0 0 1-1.91.07 4.24 4.24 0 0 0 3.96 2.94A8.51 8.51 0 0 1 2 19.54a12.02 12.02 0 0 0 6.52 1.91c7.83 0 12.11-6.49 12.11-12.12v-.55A8.72 8.72 0 0 0 24 5.13a8.46 8.46 0 0 1-2.54.7z" />
  </svg>
);

// LinkedIn
export const LinkedIn = (props) => (
  <svg
    viewBox="-2 2 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    style={{ display: "block", ...props.style }}
  >
    <g transform="scale(0.85) translate(1.5, 1.5)">
      <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM.5 8h4V23h-4V8zM8 8h3.8v2.1h.1c.5-.9 1.7-2.1 3.6-2.1C19 8 20 10.2 20 13.4V23h-4v-8.6c0-2-.7-3.4-2.3-3.4-1.3 0-2.1.9-2.4 1.9-.1.3-.1.8-.1 1.3V23h-4V8z" />
    </g>
  </svg>
);


// Pinterest
export const Pinterest = (props) => (
  <svg
    viewBox="0 0 24 24"
    style={{ enableBackground: "new 0 0 24 24" }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M12 2C6.5 2 2 6.3 2 11.5c0 3.9 2.4 7.3 6 8.9-.1-.8-.2-2 0-2.9.2-.9 1.4-5.9 1.4-5.9s-.4-.9-.4-2.2c0-2.1 1.2-3.6 2.7-3.6 1.3 0 1.9 1 1.9 2.1 0 1.3-.8 3.2-1.2 4.9-.3 1.4.7 2.6 2.1 2.6 2.6 0 4.5-2.7 4.5-6.6 0-3.5-2.5-6-6.1-6-4.2 0-6.7 3.1-6.7 6.3 0 1.3.5 2.7 1.2 3.4.1.1.1.2.1.3-.1.3-.4 1.1-.5 1.3-.1.2-.2.3-.5.2-1.4-.6-2.3-2.4-2.3-4 0-3.1 2.3-6.9 7-6.9 3.7 0 6.6 2.6 6.6 6.1 0 3.7-2.3 6.7-5.5 6.7-1.1 0-2.2-.6-2.5-1.3l-.7 2.5c-.2.8-.7 1.7-1 2.2.8.2 1.6.3 2.4.3 5.5 0 10-4.2 10-9.5C22 6.3 17.5 2 12 2z" />
  </svg>
);


export const ChevronLeft = (props) => (
    <svg viewBox="0 0 24 24" xmlSpace="preserve" {...props}>
        <path d="M16.8,19.3c0.2,0.2,0.4,0.5,0.4,0.9c0,0.3-0.1,0.6-0.4,0.9s-0.5,0.4-0.9,0.4c-0.3,0-0.6-0.1-0.9-0.4l-7.7-7.7 C7.2,13.2,7,13,6.9,12.8S6.8,12.3,6.8,12s0.1-0.5,0.2-0.8s0.2-0.5,0.4-0.7l7.7-7.7c0.2-0.2,0.5-0.4,0.9-0.4c0.3,0,0.6,0.1,0.9,0.4 s0.4,0.5,0.4,0.9c0,0.3-0.1,0.6-0.4,0.9L9.5,12L16.8,19.3z" />
    </svg>
);

export const ChevronRight = (props) => (
    <svg viewBox="0 -960 960 960" {...props}>
        <path d="M579-480 285-774q-15-15-14.5-35.5T286-845q15-15 35.5-15t35.5 15l307 308q12 12 18 27t6 30q0 15-6 30t-18 27L356-115q-15 15-35 14.5T286-116q-15-15-15-35.5t15-35.5l293-293Z" />
    </svg>
);

export const GroomIcon = (props) => (
    <svg
        viewBox="0 0 24 24"
        style={{
            enableBackground: "new 0 0 24 24",
        }}
        xmlSpace="preserve"
        {...props}
    >
        <path d="M19.9 11.1v.4c0 .3-.1.6-.3.8-.3.5-.7.8-1.2 1h-.1v.1c-.2.5-.4 1-.7 1.6-.4.8-.9 1.5-1.5 2.2-.5.6-1.1 1-1.7 1.4-.8.4-1.8.6-2.7.6-.5 0-.9-.1-1.4-.3-.8-.3-1.4-.7-2-1.3s-1.1-1.2-1.5-1.9c-.4-.7-.8-1.4-1.1-2.2-.2-.1-.4-.2-.5-.3-.7-.5-1-1.1-1-2 .1-.5.3-1 .7-1.4V8.1c0-.5.1-1 .3-1.5.2-.7.5-1.4.9-2 .7-1.1 1.8-1.8 3-2.3.8-.3 1.6-.4 2.4-.4.5 0 1 0 1.5.1s1.1.3 1.5.6c.4.3.6.7.7 1.1h.1c.4 0 .8 0 1.3.1s1 .3 1.4.7c.3.3.5.7.7 1.2.2.7.3 1.5.3 2.3v1.6c.4.3.6.7.7 1.2.1.1.1.2.2.3zM15.1 5c0 .3 0 .5-.1.8-.1.5-.4.8-.8 1.1-.2.1-.5.2-.9.3-.5.1-.9.1-1.4.1h-1.8c-.4.1-.8.1-1.1.2-.8.3-1.3.8-1.5 1.5-.1.4-.2.9-.2 1.3v.4h-.1c-.2 0-.4 0-.6-.1-.2 0-.4 0-.6.1-.2 0-.3.1-.3.3 0 .4.2.8.6.9.2.1.4.1.5.1h.1v.1c.1.2.2.5.3.7.3.8.7 1.5 1.1 2.2.4.6.9 1.2 1.5 1.7.7.5 1.4.8 2.2.8.6 0 1.2-.1 1.7-.4.5-.3 1-.7 1.3-1.1.4-.5.8-1.1 1.1-1.7.4-.7.7-1.4.9-2.2V12h.1c.2 0 .3 0 .5-.1.2 0 .4-.2.6-.4s.1-.5 0-.7v-.1h-.1c-.2-.1-.4-.1-.6-.1-.2 0-.3.1-.5.1l-.4.1v-.1c0-.5 0-1-.1-1.4-.1-.4-.2-.8-.5-1.2-.2-.2-.3-.5-.5-.7-.2-.5-.3-.9-.4-1.4.1-.4.1-.7 0-1zm.8 15.6v1.2c0 .1 0 .2-.1.3 0 .1-.1.1-.1.1h-.2c-.8-.3-1.6-.6-2.3-1h-.1V20c.8-.3 1.5-.6 2.3-.9.2-.1.4 0 .5.1v1.4zm-7.8.1v-1.2c0-.1 0-.2.1-.3 0-.1.1-.1.2-.1h.2c.2.1.4.2.6.2.6.2 1.1.4 1.7.7h.1v1.2c-.7.3-1.5.6-2.2.9 0 0-.1 0-.1.1h-.2c-.1 0-.1 0-.2-.1 0-.1-.1-.1-.1-.2-.1-.4-.1-.8-.1-1.2zm3.9.7h-.4c-.2 0-.4-.1-.4-.4v-.8c0-.2.2-.4.4-.4h.8c.2 0 .4.1.4.4v.9c0 .2-.2.3-.4.3H12z" />
    </svg>
);

export const BrideIcon = (props) => (
    <svg
        viewBox="0 0 24 24"
        style={{
            enableBackground: "new 0 0 24 24",
        }}
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="path"
            className="st0"
            d="M11.6 22c-.4-.1-.8-.1-1.2-.3-1-.3-1.8-.9-2.5-1.7-.8-.9-1.4-1.9-1.8-3 0 0-.1-.1-.1-.2-.1.6 0 1.2.2 1.7.2.4.4.9.5 1.4.1.7.1 1.3-.1 2l-1.1-.3c.1-.5.2-1.1 0-1.6l-.3-.9c-.4-.9-.5-1.9-.3-2.8l.3-.9c.2-.5.3-1 .3-1.6 0-.7 0-1.4.2-2 .4-1.9 1.5-3.3 3.2-4.3 1-.6 2.3-.9 3.5-.8 1.6.1 3 .7 4.2 1.8 1 1 1.7 2.2 1.9 3.6.1.5.1 1 .1 1.5 0 .6.1 1.2.4 1.8.5.9.5 1.9.3 2.9l-.3.9c-.3.7-.4 1.4-.2 2.1v.2l-1.1.3c-.2-.6-.2-1.1-.2-1.7 0-.6.2-1.1.5-1.6.2-.5.3-1 .3-1.6v-.2c-.2.5-.4.9-.6 1.4-.6 1.1-1.3 2.1-2.3 2.8-.7.6-1.6.9-2.5 1h-.2l-1.1.1zm-4.7-6.2v.1c.4 1.4 1.1 2.7 2.1 3.7 1.6 1.6 4.1 1.6 5.7.1 1.2-1.1 1.9-2.5 2.3-4 .1-.5.1-1 .2-1.5-1.2-.3-2-1-2.6-2 0 .1-.1.1-.1.1-.4.4-.7.8-1.1 1.2-1.5 1.2-3.2 1.8-5.1 2.1-.3.1-.8.1-1.4.2z"
        />
        <path
            id="path_1"
            className="st0"
            d="M16.5 6.9c-3-1.9-6-1.9-8.9 0-.2-1.2.3-3 1.8-4.1 1.5-1.1 3.5-1.1 5.1-.1 1.5 1 2.2 2.8 2 4.2z"
        />
    </svg>
);

export const Necklace = (props) => (
    <svg
        viewBox="0 0 512 512"
        style={{
            enableBackground: "new 0 0 512 512",
        }}
        xmlSpace="preserve"
        {...props}
    >
        <path d="M413.72 30.825a7.836 7.836 0 0 0-11.083.043l-104.179 104.99-33.214-33.471a12.928 12.928 0 0 0-9.243-3.848 12.937 12.937 0 0 0-9.243 3.847l-36.229 36.51L103.334 30.867a7.837 7.837 0 0 0-11.126 11.039l107.28 108.115-28.653 28.877c-5.048 5.088-5.048 13.367 0 18.456l75.922 76.513a12.93 12.93 0 0 0 9.243 3.848c3.499 0 6.781-1.368 9.243-3.847l30.914-31.155a7.838 7.838 0 0 0-11.126-11.039l-29.03 29.257-72.242-72.804L256 115.322l72.242 72.804-24.547 24.738a7.837 7.837 0 0 0 11.126 11.039l26.344-26.55c5.048-5.088 5.048-13.367 0-18.456l-31.668-31.914L413.763 41.907a7.838 7.838 0 0 0-.043-11.082zM298.577 388.343l-37.014-37.303a7.836 7.836 0 0 0-11.126 0l-37.014 37.302a7.837 7.837 0 0 0 0 11.039l37.014 37.303a7.836 7.836 0 0 0 11.126 0l37.014-37.302a7.836 7.836 0 0 0 0-11.039zM256 420.039l-25.974-26.177L256 367.686l25.974 26.177L256 420.039z" />
        <path d="m298.577 182.606-37.014-37.302a7.833 7.833 0 0 0-11.126 0l-37.014 37.302a7.837 7.837 0 0 0 0 11.039l37.014 37.302a7.837 7.837 0 0 0 11.126 0l37.014-37.302a7.836 7.836 0 0 0 0-11.039zM256 214.302l-25.974-26.177L256 161.95l25.974 26.177L256 214.302z" />
        <path d="M509.682 130.654a7.835 7.835 0 0 0-11.082.043l-40.341 40.656-3.945-3.976c-2.461-2.482-5.744-3.848-9.243-3.848s-6.781 1.367-9.243 3.847l-21.158 21.32c-5.049 5.088-5.049 13.367.001 18.456l4.032 4.064-33.316 33.575-13.364-13.469a12.924 12.924 0 0 0-9.243-3.848 12.933 12.933 0 0 0-9.243 3.847l-40.423 40.737c-5.048 5.088-5.048 13.367 0 18.456l13.451 13.557-32.672 32.925-28.651-28.874a12.924 12.924 0 0 0-9.243-3.848 12.933 12.933 0 0 0-9.243 3.847l-28.651 28.875-32.672-32.926 13.452-13.556c5.048-5.088 5.048-13.367-.001-18.456l-4.822-4.859a7.836 7.836 0 1 0-11.124 11.039l3.025 3.048-36.744 37.03-36.743-37.029 36.743-37.028 15.056 15.172a7.837 7.837 0 0 0 11.124-11.039l-16.938-17.068a12.924 12.924 0 0 0-9.243-3.848 12.933 12.933 0 0 0-9.243 3.847l-13.365 13.469-33.312-33.575 4.033-4.065c5.048-5.088 5.048-13.367-.001-18.456l-21.156-21.318a12.924 12.924 0 0 0-9.243-3.848 12.933 12.933 0 0 0-9.243 3.847l-3.946 3.977L13.4 130.697c-3.051-3.072-8.013-3.09-11.082-.043a7.836 7.836 0 0 0-.044 11.082l40.428 40.743-6.169 6.217c-5.048 5.088-5.048 13.367 0 18.456l21.155 21.319a12.928 12.928 0 0 0 9.243 3.848c3.499 0 6.781-1.368 9.242-3.847l6.084-6.131 33.315 33.575-16.018 16.143c-5.048 5.088-5.048 13.367 0 18.456l40.423 40.737a12.928 12.928 0 0 0 9.243 3.848c3.499 0 6.781-1.368 9.243-3.847l15.933-16.057 32.671 32.925-36.231 36.513c-5.048 5.088-5.048 13.367 0 18.456l75.922 76.512c2.462 2.482 5.744 3.848 9.243 3.848s6.781-1.367 9.243-3.847l42.212-42.54a7.837 7.837 0 0 0-11.126-11.039L256 466.665l-72.242-72.803L256 321.06l72.242 72.803-13.25 13.353a7.838 7.838 0 0 0 11.126 11.039l15.047-15.166c5.048-5.088 5.048-13.367 0-18.456l-36.231-36.512 32.672-32.925 15.932 16.056a12.928 12.928 0 0 0 9.243 3.848c3.499 0 6.781-1.368 9.243-3.847l40.423-40.74c5.048-5.088 5.048-13.367 0-18.456l-16.018-16.143 33.314-33.574 6.084 6.131a12.927 12.927 0 0 0 9.243 3.847c3.499 0 6.781-1.368 9.243-3.847l21.154-21.321c5.048-5.088 5.048-13.367 0-18.456l-6.169-6.216 40.428-40.743a7.834 7.834 0 0 0-.044-11.081zM66.931 215.535l-17.475-17.611 17.475-17.611 17.476 17.611-17.476 17.611zm332.592 65.752-36.743 37.03-36.743-37.03 36.743-37.028 36.743 37.028zm45.546-65.752-17.476-17.611 17.477-17.612 17.475 17.612-17.476 17.611z" />
    </svg>
);

export const BackspaceButton = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g data-name="Layer 2">
            <g data-name="Layer 1">
                <path
                    style={{
                        fill: "none",
                    }}
                    d="M0 0h24v24H0z"
                />
                <path d="M7.77 5.66h14.8v12.68H7.77L1.43 12Zm13.74 1H8.45a.22.22 0 0 0-.18.08C6.56 8.5 4.85 10.2 3.15 11.91l-.09.09.07.07c1.72 1.72 3.44 3.43 5.15 5.16a.22.22 0 0 0 .17.06h13.06Z" />
                <path d="m17.49 7.9.73.74L14.87 12l3.37 3.36-.76.75-3.34-3.34-3.35 3.33-.79-.74L13.39 12 10 8.66l.77-.75 3.35 3.35Z" />
            </g>
        </g>
    </svg>
);

export const HeartIcon = (props) => (
    <svg viewBox="0 0 256 256" {...props}>
        <path d="M150 70.2c-7.1 1.1-14.6 4.8-18.9 9.2l-3.4 3.5-3.9-3.9c-6.9-6.9-11.6-8.5-24.8-8.5-10.9 0-11.8.2-18.1 3.2-12 5.9-18.9 16.1-21.1 31.1-1 6.7-.9 9.2.5 16.3 4 20.5 15.9 34.3 51.3 59.4 8.1 5.8 15.5 10.5 16.4 10.5 1 0 6.7-3.5 12.8-7.8 41.6-29.1 55.2-46.7 55.5-71.7.1-10.5-2-18.5-6.8-25.4-8.1-11.8-24.3-18.3-39.5-15.9" />
    </svg>
);

export const PeopleIcon = (props) => (
    <svg viewBox="0 0 256 256" {...props}>
        <path d="M119 54.9c-8.4 2.7-15.8 10.1-18.6 18.3-3.3 10.1.4 23.2 8.6 29.9 4.2 3.5 12.8 6.9 17.4 6.9 18.7 0 33-19.3 27.2-36.8-2.1-6.1-8.4-13.5-14-16.4-4.4-2.3-16.1-3.4-20.6-1.9m-49.5 27c-19.1 8.6-15.1 35.7 5.8 39.6C86.8 123.7 99 113 99 100.9c-.1-15.2-15.7-25.3-29.5-19m98.5-.6c-5.3 2.5-8 5.1-10.5 10-3.1 6.3-3.3 12.5-.4 18.4 8.2 17 32.8 15.3 38.8-2.6 4.4-13.3-6.1-27.2-20.4-27-2.7 0-6.1.6-7.5 1.2m-61 34.6c-7.7 2.4-13.8 8-16.1 14.8-2 5.5-2 55.3 0 57.6 1.2 1.5 5 1.7 36.1 1.7s34.9-.2 36.1-1.7c2-2.3 2-52.1 0-57.6-1.7-5-6.4-10.3-11.5-13-3.8-2-5.7-2.2-23.1-2.4-10.4-.1-20.1.2-21.5.6M62 129c-6.4 2.2-12 7.7-13.8 13.8-.7 2.3-1.2 10.7-1.2 20.8 0 15.2.2 17.2 2 20.2 3 5 7.1 6.2 20.5 6.2H81v-27.8c0-15.2.3-29.4.6-31.5l.7-3.7h-7.4c-4.6.1-9.5.8-12.9 2m110.4 1.1c.3 1.7.6 15.9.6 31.5V190h12.3c10.3 0 12.7-.3 15.4-2 5.6-3.4 6.3-6 6.3-24.6 0-19.6-.8-23.3-6.5-29-5.2-5.2-11.6-7.4-21.3-7.4h-7.4z" />
    </svg>
);

export const WineGlasses = (props) => (
    <svg width={24} height={24} viewBox="0 0 256 256" {...props}>
        <path d="M121.8 37.1c-1.8 1-5.5 18.7-4.4 21.5.3.9 1.5 1.4 2.8 1.2 2-.3 2.5-1.4 4-7.8.9-4.1 1.7-8.9 1.7-10.6.1-3.7-1.7-5.7-4.1-4.3m-22.5 2.6c-2.2.8-1.4 4.5 2.9 14.5 2.9 6.5 4.9 9.8 6.2 10.2 4.9 1.3 4.7-1.8-.8-14-4.4-9.6-5.9-11.6-8.3-10.7m39.5 15.5c-7.5 2.7-13.9 5.6-14.1 6.3-.6 1.3 10.4 54.2 12.2 58.8 3.4 8.7 12.4 14.7 22.2 14.7 5.3 0 5.8.2 6.7 2.7.5 1.6 4 11.1 7.6 21.1 3.6 10.1 6.6 18.7 6.6 19.1s-2.4 1.5-5.4 2.4c-5.9 1.9-8.1 3.8-7.2 6.2s4.2 1.8 19.6-3.8c12.2-4.5 14.6-5.7 14.8-7.5.5-3.4-2.3-3.8-9.1-1.3-3.3 1.2-6.1 2-6.3 1.9-.6-.7-15.6-42.9-15.3-43.2 10.8-6.9 15.5-18.7 11.8-29.5-1.2-3.4-25.5-49.8-27.1-51.9-1.4-1.7-1.6-1.6-17 4m-57.8.3c-.7.8-1 2.1-.7 2.9.6 1.4 13.9 9.9 17.5 11 2.7.9 4.7-2.3 2.9-4.7C99.5 63.3 84.2 54 82.9 54c-.4 0-1.2.7-1.9 1.5m9.3 25.3c-2 1.2-23.4 53.1-24 58.2-1 8.8 4.1 18.7 12.5 24l2.3 1.5-5.7 21.5c-3.2 11.8-5.9 21.7-6.1 21.9-.1.2-3-.3-6.4-1.2-6.8-1.7-8.9-1.4-8.9 1.3 0 2.4 1.6 3.5 7 4.8 2.5.7 9.3 2.5 15.3 4.1 9.5 2.6 10.9 2.8 12.2 1.5 2.5-2.5.2-4.9-6-6.4-3.2-.8-5.9-1.9-6.2-2.5-.2-.7 2.1-10.5 5.1-21.9 3.1-11.4 5.6-20.9 5.6-21.2 0-.2 1.3-.4 2.8-.4 9.5 0 20.6-7.2 23.6-15.3 2.2-5.7 9-60.7 7.7-62-.5-.5-6.3-2.4-12.8-4.2-16.4-4.4-16.7-4.5-18-3.7" />
    </svg>
);

export const BellIcon = (props) => (
    <svg width={24} height={24} viewBox="0 0 256 256" {...props}>
        <path d="M125.4 49c-2.9 1.2-3.5 2.3-4.3 8.3-.6 5-.6 5.1-5.1 6.2-14.8 3.8-26.9 15.3-31.9 30.3-1.7 5-2.1 8.6-2.1 19.4 0 23.5-3 33.2-13.4 44.6-6.7 7.1-8 11.6-5.1 17.1 3.1 6.1 2.6 6.1 65 6.1 62.1 0 60.8.1 64-6 3-5.9 2.1-9.3-4.7-16.7-11-12.2-13.7-21.5-13.8-48.1 0-23.5-11.5-39.5-33-46.3l-5.5-1.7-.5-5.1c-.7-6.9-4.5-10.1-9.6-8.1M104 188.5c0 2.5 3.6 8.8 6.7 11.7 3.9 3.7 11.7 7 16.7 7 9.5 0 18.6-5.3 22.6-13.3 3.7-7.2 4.8-6.9-22-6.9-20.9 0-24 .2-24 1.5" />
    </svg>
);

export const PrevBtn = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M16.8 19.3c.2.2.4.5.4.9 0 .3-.1.6-.4.9s-.5.4-.9.4c-.3 0-.6-.1-.9-.4l-7.7-7.7c-.1-.2-.3-.4-.4-.6s-.1-.5-.1-.8.1-.5.2-.8.2-.5.4-.7l7.7-7.7c.2-.2.5-.4.9-.4.3 0 .6.1.9.4s.4.5.4.9c0 .3-.1.6-.4.9L9.5 12z" />
    </svg>
);

export const MapIcon = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="m20.5 3-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5M15 19l-6-2.11V5l6 2.11z" />
    </svg>
);

export const Clock = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8" />
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67Z" />
    </svg>
);

export const Pin_Location = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7M7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9" />
        <path d="M9.5 9c0-.663.264-1.299.732-1.768a2.504 2.504 0 0 1 3.536 0 2.504 2.504 0 0 1 0 3.536 2.504 2.504 0 0 1-3.536 0A2.5 2.5 0 0 1 9.5 9" />
    </svg>
);

export const Add_Calender = (props) => (
    <svg viewBox="0 0 24 24" xmlSpace="preserve" {...props}>
        <path
            className="st0"
            d="M18 22.9v-3h-3v-2h3v-3h2v3h3v2h-3v3zm-12-2c-.5 0-1-.2-1.4-.6s-.6-.9-.6-1.4V7c0-.5.2-1 .6-1.4.4-.3.9-.5 1.4-.5h1v-2h2v2h6v-2h2v2h1c.5 0 1 .2 1.4.6.3.3.5.8.5 1.3v6c-.3 0-.7-.1-1-.1s-.7 0-1 .1v-2H6v7.9h7c0 .3 0 .7.1 1 0 .3.1.7.3 1z"
        />
    </svg>
);

export const Normal_Back_Arrow = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z" />
    </svg>
);

export const Normal_Front_Arrow = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
    </svg>
);

export const Tick = (props) => (
    <svg viewBox="0 0 16 16" {...props}>
        <rect width={16} height={16} id="icon-bound" fill="none" />
        <path d="M0,9.014L1.414,7.6L5.004,11.189L14.593,1.6L16.007,3.014L5.003,14.017L0,9.014Z" />
    </svg>
);

export const User = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M21 20a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2 6 6 0 0 1 6-6h6a6 6 0 0 1 6 6m-9-8a5 5 0 1 0-5-5 5 5 0 0 0 5 5" />
    </svg>
);

export const Star = (props) => (
    <svg viewBox="0 0 17 17" {...props}>
        <path d="M16.647 7.017h-6.225L8.5 1.097l-1.923 5.92H.353l5.035 3.658-1.922 5.92L8.5 12.936l5.035 3.659-1.922-5.92zm-5.014 6.96L8.5 11.699l-3.133 2.277 1.197-3.685-3.133-2.274h3.873L8.5 4.333l1.196 3.684h3.873l-3.133 2.275z" />
    </svg>
);

export const Share = (props) => (
    <svg viewBox="0 0 512 512" {...props}>
        <path d="M385 464q-28 0-46-19-19-19-19-46 0-9 1-11l-150-85q-17 17-42 17-27 0-46-19t-19-46q0-26 19-44 19-19 46-19 25 0 42 17l150-84q-1-3-1-14 0-26 19-44 18-19 45-19 26 0 45 19 18 18 19 44 0 27-19 46t-45 19q-23 0-43-17l-150 85q1 2 1 11 0 10-1 13l150 85q20-17 44-17 30 0 46 19t16 45-16 45-46 19" />
    </svg>
);

export const Info = (props) => (
    <svg viewBox="-2 -2 24 24" {...props}>
        <path d="M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10m0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-10a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
    </svg>
);

export const Numpad = (props) => (
    <svg viewBox="0 0 52 52" {...props}>
        <path d="M8.55 36.91A6.55 6.55 0 1 1 2 43.45a6.54 6.54 0 0 1 6.55-6.54m17.45 0a6.55 6.55 0 1 1-6.55 6.54A6.55 6.55 0 0 1 26 36.91m17.45 0a6.55 6.55 0 1 1-6.54 6.54 6.54 6.54 0 0 1 6.54-6.54M8.55 19.45A6.55 6.55 0 1 1 2 26a6.55 6.55 0 0 1 6.55-6.55m17.45 0A6.55 6.55 0 1 1 19.45 26 6.56 6.56 0 0 1 26 19.45m17.45 0A6.55 6.55 0 1 1 36.91 26a6.55 6.55 0 0 1 6.54-6.55M8.55 2A6.55 6.55 0 1 1 2 8.55 6.54 6.54 0 0 1 8.55 2M26 2a6.55 6.55 0 1 1-6.55 6.55A6.55 6.55 0 0 1 26 2m17.45 0a6.55 6.55 0 1 1-6.54 6.55A6.55 6.55 0 0 1 43.45 2" />
    </svg>
);

export const ThumbsUp = (props) => (
    <svg viewBox="0 0 32 32" {...props}>
        <path d="M28.869 20.55a4 4 0 0 0-.36-.395c.171-.153.296-.362.421-.551a4 4 0 0 0 .445-.867c.248-.706-.118-1.461-.577-1.988a2 2 0 0 0-.22-.216c.082-.099.161-.203.239-.303.204-.262.428-.535.487-.873.061-.344.021-.674-.067-1.01-.176-.672-.76-1.192-1.329-1.541a3.6 3.6 0 0 0-.588-.279c-.172-.065-.374-.08-.554-.103-.311-.038-.628-.032-.941-.038l-.243-.002c-.85 0-1.696.068-2.545.105-.832.034-1.667.04-2.5.04-.002-.39-.001-.78-.016-1.17-.018-.492-.029-.981.019-1.473.033-.191.076-.38.109-.57.057-.336.122-.668.166-1.008.082-.615.153-1.243.074-1.862a11 11 0 0 0-.187-1.105c-.082-.357-.187-.733-.384-1.045-.113-.18-.254-.342-.384-.508a4 4 0 0 0-.349-.395c-.208-.206-.451-.382-.682-.563-.208-.162-.416-.327-.64-.468a2.9 2.9 0 0 0-.781-.336.804.804 0 0 0-.975.555c-.02.074-.016.149-.015.223-.012.018-.033.026-.045.045a.74.74 0 0 0-.101.376c-.04.291-.068.582-.103.872-.12.864-.299 1.722-.464 2.58-.133.701-.233 1.41-.488 2.077-.141.316-.299.626-.452.936-.197.395-.435.771-.655 1.153-.43.747-.871 1.487-1.385 2.178q-.291.364-.612.706a6 6 0 0 1-.651.594 4 4 0 0 1-.384.263c-.093.053-.189.097-.284.143l.003-.145a.78.78 0 0 0-.775-.773c-.059 0-.114.022-.17.035-.039-.009-.076-.029-.114-.029l-.043.002c-.995.099-2.001.115-3.002.138-.506.011-1.012.025-1.52.019-.514-.004-1.033-.065-1.545-.015-.047.005-.086.019-.13.028a.8.8 0 0 0-.244-.05c-.407 0-.81.357-.783.783.023.359.05.712.053 1.071l.006 1.121c.002.739-.017 1.478-.008 2.217q.031 2.188.031 4.373c0 .712-.019 1.421-.032 2.131-.011.624-.004 1.247-.017 1.869-.004.2.084.38.221.511.138.173.337.294.566.277 1.085-.08 2.173-.156 3.261-.147q.47.004.943.002.336-.002.674-.002c.51 0 1.031-.015 1.537.042.185.021.399-.092.525-.218a.7.7 0 0 0 .16-.243c.339-.067.623-.36.612-.719q-.005-.09-.013-.179l.075.053c.615.499 1.205 1.034 1.865 1.474.315.21.628.433.964.609.382.2.783.37 1.193.502.749.244 1.533.324 2.316.384.376.029.754.053 1.13.092.361.034.72.059 1.083.061 1.543.004 3.082-.092 4.623-.128.46-.011.918-.034 1.373-.103a10 10 0 0 0 1.058-.202c.145-.04.292-.088.432-.145.12-.05.246-.094.359-.162.109-.065.208-.147.309-.227.225-.176.445-.353.632-.573.191-.225.304-.485.441-.743.097-.185.187-.38.231-.584a2.85 2.85 0 0 0-.055-1.396 5.4 5.4 0 0 0-.273-.731c-.084-.183-.233-.338-.369-.485l-.206-.218.09-.072a2.7 2.7 0 0 0 .491-.537c.162-.218.292-.452.382-.71.075-.214.105-.447.147-.668a2.2 2.2 0 0 0-.002-.85c-.065-.352-.266-.648-.484-.917M8.733 26.719l-.489-.002c-.538.004-1.079.002-1.617.013-.544.013-1.09.042-1.635.055-.244.008-.489.004-.733 0-.086 0-.172.004-.259.003-.007-1.095.007-2.191.007-3.287.002-1.457.025-2.916.053-4.373.015-.739.036-1.478.044-2.217q.004-.559.002-1.121c.001-.125-.001-.249.002-.374q.56-.038 1.124-.053l1.52-.048c.496-.013.995-.011 1.491-.013q.553-.002 1.108-.011c.022.516.047 1.032.056 1.549.013.722.029 1.445.04 2.167.01.747.032 1.491.055 2.236q.03 1.105.04 2.209c.008.628-.013 1.256.01 1.885.013.304.031.607.036.909q.002.23-.002.459-.425.02-.853.014m19.114-2.101.008-.006.016-.012zm.071-6.346q-.014.06-.035.118c-.102.212-.227.42-.362.612l-.086.092c-.171.107-.359.187-.533.29-.258.155-.439.409-.439.718 0 .336.218.58.495.741.123.071.25.137.371.215q.203.18.377.389.075.11.134.23.021.067.036.136.001.064-.002.129c-.031.203-.066.41-.13.603a3 3 0 0 1-.191.31 2.4 2.4 0 0 1-.32.312 9 9 0 0 1-.37.254c-.218.145-.378.302-.462.556-.107.317.034.626.244.857.232.256.473.504.69.772q.064.09.116.187c.067.183.125.367.161.558q.013.158.004.316a2 2 0 0 1-.046.184q-.057.11-.112.223c-.053.109-.103.218-.166.32q-.195.21-.417.389a2 2 0 0 1-.255.156 6.4 6.4 0 0 1-1.211.292c-.755.078-1.519.052-2.276.08-.741.025-1.482.031-2.223.044-.768.013-1.531.048-2.299.004-.694-.04-1.391-.055-2.084-.138a7.4 7.4 0 0 1-1.505-.421 10 10 0 0 1-1.3-.772 29 29 0 0 1-1.225-.881c-.222-.173-.442-.346-.669-.509-.185-.131-.382-.242-.568-.371l-.02-.019a.8.8 0 0 0-.274-.156l-.002-.036c-.021-.728-.032-1.457-.046-2.186-.015-.739-.04-1.478-.052-2.217-.013-.754-.015-1.506-.015-2.261.002-.611-.002-1.222-.004-1.833l.001-.27.008-.005c.261-.18.574-.294.859-.43.378-.183.728-.456 1.044-.726.275-.233.519-.497.76-.762.267-.292.516-.603.747-.924.428-.598.781-1.243 1.157-1.871.183-.304.374-.602.55-.909.176-.302.332-.615.485-.93q.264-.534.433-1.105c.052-.174.103-.349.128-.531q.034-.255.065-.512c.175-1.246.443-2.477.651-3.719q.23.158.451.332c.111.088.221.178.321.278q.22.22.416.467.082.115.15.237c.166.458.26.935.332 1.416.063.585.007 1.178-.066 1.761-.053.37-.111.743-.185 1.11-.082.397-.09.802-.105 1.205-.029.831.071 1.659.023 2.49-.016.256.14.475.349.607a.73.73 0 0 0 .548.256c.609-.004 1.216-.052 1.825-.08.563-.029 1.127-.036 1.69-.055a60 60 0 0 1 1.642-.031c.474-.002.944.008 1.413.064.142.025.276.061.411.109q.209.108.401.245.14.119.264.255.06.093.112.192.028.09.047.183l.004.092c-.06.106-.131.205-.205.302a2.6 2.6 0 0 1-.298.331 3 3 0 0 1-.329.182c-.34.166-.559.596-.435.964a.82.82 0 0 0 .428.506q.085.037.172.072.155.076.295.175.185.16.344.345.074.11.133.228.02.058.035.117zm-.395 4.62-.011.015-.034.045z" />
    </svg>
);

export const User_Second = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4" />
    </svg>
);
